<template>
    <div>
        <b-tab title="Tab 7">
            <b-card-text>
                <h3>Prevenzione incendi</h3>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-6">
                        Certificato di prevenzione incendi (CPI)(Centrale Termica sopra 100.000 Kcal, autorimessa con autoveicoli, carta o legna sopra i 50 q.li, serbatoi di gpl sopra i 0,5 mc, diesel tank, superficie coperta sopra i 1000 mq.)
                    </div>
                    <div class="form-group col-md-3">
                        <label for="certificato_prevenzione_si"><input type="radio" value="si" v-model="prevenzione.cassetta" style="margin-right:5px;">Si</label>
                        <label for="certificato_prevenzione_no"><input type="radio" value="no" v-model="prevenzione.cassetta" style="margin-left:10px;margin-right:5px">No</label><br>
                        <label for="anno_certificazione">Anno</label>
                        <input type="text" class="form-control" v-model="prevenzione.anno_certificazione"> 
                    </div>
                    <div class="form-group col-md-3">
                        Solo con attività soggette
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-6">
                        Piano di emergenza con allegato planimetria evacuazione
                    </div>
                    <div class="form-group col-md-3">
                        <label for="piano_emergenza_si"><input type="radio" value="si" v-model="prevenzione.piano_emergenza" style="margin-right:5px;">Si</label>
                        <label for="piano_emergenza_no"><input type="radio" value="no" v-model="prevenzione.piano_emergenza" style="margin-left:10px;margin-right:5px">No</label><br>
                        <label for="anno_piano_emergenza">Anno</label>
                        <input type="text" class="form-control" v-model="prevenzione.anno_piano_emergenza">
                    </div>
                    <div class="form-group col-md-3">
                        Solo con dipendenti>10
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-6">
                        Prova evacuazione annuale
                    </div>
                    <div class="form-group col-md-3">
                        <label for="prova_evacuazione_annuale_si"><input type="radio" value="si" v-model="prevenzione.prova_evacuazione_annuale" style="margin-right:5px;">Si</label>
                        <label for="prova_evacuazione_annuale_no"><input type="radio" value="no" v-model="prevenzione.prova_evacuazione_annuale" style="margin-left:10px;margin-right:5px">No</label><br> 
                        <label for="prova_evacuazione_annuale_anno">Anno</label>
                        <input type="text" class="form-control" v-model="prevenzione.anno_prova_evacuazione_annuale">
                    </div>
                    <div class="form-group col-md-3">
                        Solo con dipendenti>10
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-6">
                        Registro presidi di emergenza
                    </div>
                    <div class="form-group col-md-3">
                        <label for="registro_piani_emergenza_si"><input type="radio" value="si" v-model="prevenzione.registro_piani_emergenza" style="margin-right:5px;">Si</label>
                        <label for="registro_piani_emergenza_no"><input type="radio" value="no" v-model="prevenzione.registro_piani_emergenza" style="margin-left:10px;margin-right:5px">No</label><br>
                        <label for="registro_piani_emergenza_anno">Anno</label>
                        <input type="text" class="form-control" v-model="prevenzione.registro_piani_emergenza_anno">
                    </div>
                    <div class="form-group col-md-3">
                        Solo con CPI
                    </div>
                </div>
                <h3>Lista principali documenti presenti in azienda</h3>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-1">
                        1.
                    </div>
                    <div class="form-group col-md-4">
                        Planimetria locali
                    </div>
                    <div class="form-group col-md-3">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="prevenzione.planimetria_locali_data">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="prevenzione.planimetria_locali_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-1">
                        2.
                    </div>
                    <div class="form-group col-md-4">
                        Dichiarazione conformità imp. elettrico (L. 37/08 ex 46/90)
                    </div>
                    <div class="form-group col-md-3">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="prevenzione.dichiarazione_conformita_elettrico_data">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="prevenzione.dichiarazione_conformita_elettrico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-1">
                        3.
                    </div>
                    <div class="form-group col-md-4">
                        Dichiarazione conformità imp. termico (L. 37/08 ex 46/90)
                    </div>
                    <div class="form-group col-md-3">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="prevenzione.dichiarazione_conformita_termico_data">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="prevenzione.dichiarazione_conformita_termico_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-1">
                        4.
                    </div>
                    <div class="form-group col-md-4">
                        Verifica periodica impianto di messa a terra (ogni 2 se esiste CPI o 5 anni in assenza di CPI)
                    </div>
                    <div class="form-group col-md-3">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="prevenzione.verifica_periodica_impianto_data">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="prevenzione.verifica_periodica_impianto_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
                <hr>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-1">
                        5.
                    </div>
                    <div class="form-group col-md-4">
                        Agibilità dei locali
                    </div>
                    <div class="form-group col-md-3">
                        <label>Data</label>
                        <input type="date" class="form-control" v-model="prevenzione.agibilita_locali_data">
                    </div>
                    <div class="form-group col-md-4">
                        <label>Note</label>
                        <textarea lass="form-control" v-model="prevenzione.agibilita_locali_note" rows="3" style="width:100%;border-radius:7px"></textarea>
                    </div>
                </div>
            </b-card-text>
        </b-tab>
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriIdentificazione()" style="margin-top: 10px;background:#00467f">Salva</button> -->
        <!-- <button class="btn float-right" type="button" v-on:click="salvaValoriDati()" style="margin-top: 10px;background:#00467f">Salva</button>
        <router-link :to="'valutazione-a?idCliente='+idCliente"><button class="btn float-right" type="button" style="margin-top: 10px;margin-right:20px;background:#00467f">Avanti</button></router-link>
        <router-link to="/clienti" class="btn float-right" style="margin-top: 10px;margin-right:10px;background:#00467f">Indietro</router-link> -->        
    </div>
</template>
<script>
// import Card from "@/components/Cards/Card.vue";
import Services from '@/services/Services';

export default {
    components: {
        // Card
    },

    data() {
        return {
            prevenzione: {},
            
            idCliente: null,
            idSoggetto: null,
        }
    },

    props: {
        prevenzioneValori: {
            type: Object,
            required: true
        }
    },
    computed: {},

    methods: {
        addPrevenzioneoValori() {
            this.prevenzione = Object.assign({}, this.prevenzioneValori);
        },

    },
    created() {
        this.addPrevenzioneoValori();
    },
    
    // mounted() {
    //     this.main();
    // } 

};
</script>
<style scoped>
    .row-color:hover {
    background-color: #00467f53;
    }
    label {
        font-size: 16px;
    }

    .label-switch {
            position: relative;
        /* display: inline-block; */
        display: table-cell;
        padding-right: 10px;
        padding-left: 10px;
        font-size: 16px;
    }
    .switch {
        position: relative;
        /* display: inline-block; */
        display: table-cell;
        width: 55px;
        height: 34px;
    }

    .switch input { 
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 0px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }
    input:checked + .slider {
        background-color: #00467f;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #00467f;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }
    .slider.round:before {
        border-radius: 50%;
    }
</style>
